import ChevronSortDown20 from '@carbon/icons-react/es/chevron--sort--down/20';
import Download16 from '@carbon/icons-react/es/download/16';
import Grid16 from '@carbon/icons-react/es/grid/16';
import List16 from '@carbon/icons-react/es/list/16';
import { Select } from 'antd';
import { debounce } from 'lodash';
import React, { ChangeEvent, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import { IconShell } from 'components/atoms/icon-shell';
import { Input } from 'components/atoms/input';
import { Radio } from 'components/atoms/radio';
import { useTranslate } from 'hooks/use-translation';
import { ListType } from './attachment-renderer';
import {
  Container,
  CountText,
  SelectWithLabel,
  ViewContainer,
} from './attachments-filters.styles';

export enum SortOptions {
  ByNewestFirst = 'ByNewestFirst',
  ByOldestFirst = 'ByOldestFirst',
  ByAscending = 'ByAscending',
  ByDescending = 'ByDescending',
}

type AttachmentsFilterPropTypes = {
  listType: ListType;
  count?: number;
  searchText: string;
  setSearchText: (value: string) => void;
  onDownload?: () => void;
  onSearch: (searchString: string) => void;
  onListTypeChange?: (listType: ListType) => void;
  onSortChange?: (sortType: SortOptions) => void;
};

const { Option } = Select;

export const AttachmentsFilter = ({
  count,
  listType,
  searchText,
  setSearchText,
  onListTypeChange,
  onDownload,
  onSortChange,
  onSearch,
}: AttachmentsFilterPropTypes) => {
  const translate = useTranslate();

  const handleOnListChange = (e) => {
    onListTypeChange?.(e.target.value);
  };

  const debouncedonSearch = useMemo(() => debounce(onSearch, 500), [onSearch]);

  const handleSort = (value: SortOptions) => {
    onSortChange?.(value);
  };

  return (
    <div>
      <Container>
        <Input
          placeholder={translate('attachments_search')}
          value={searchText}
          onChange={(e: ChangeEvent<HTMLInputElement>) => {
            setSearchText(e.target.value.trim());
            debouncedonSearch(e.target.value.trim());
          }}
        />
      </Container>
      <ViewContainer>
        <Radio.Group
          defaultValue="list"
          onChange={handleOnListChange}
          value={listType}
        >
          <Radio.Button value="list">
            <IconShell icon={<List16 />} />
          </Radio.Button>
          <Radio.Button value="grid">
            <IconShell icon={<Grid16 />} />
          </Radio.Button>
        </Radio.Group>
        <Button type="text" onClick={() => onDownload?.()}>
          <Download16 />
        </Button>
      </ViewContainer>
      <Container>
        <CountText>
          <FormattedMessage id="files_count" values={{ count }} />
        </CountText>
        <SelectWithLabel>
          <FormattedMessage id="sort_by" />
          <Select
            onChange={handleSort}
            defaultValue={SortOptions.ByNewestFirst}
            style={{ minWidth: 80, maxWidth: 160 }}
            bordered={false}
            suffixIcon={<ChevronSortDown20 />}
          >
            <Option value={SortOptions.ByNewestFirst}>
              <FormattedMessage id="recently_uploaded" />
            </Option>
            <Option value={SortOptions.ByOldestFirst}>
              <FormattedMessage id="oldest_uploaded" />
            </Option>
            <Option value={SortOptions.ByAscending}>
              <FormattedMessage id="ascending_alphabetics" />
            </Option>
            <Option value={SortOptions.ByDescending}>
              <FormattedMessage id="descending_alphabetics" />
            </Option>
          </Select>
        </SelectWithLabel>
      </Container>
    </div>
  );
};
